const styles = (theme) => ({
  disableStyle: {
    backgroundColor: theme.tooltipBGColor
  },
  flexRow: {
    minWidth: 167,
    maxWidth: 167, 
  },
  headerContainer: {
    margin: "14 0 21 0",
  },
  inputContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  selectRoot: {
    marginTop: 0,
    marginBottom: 0
  },
  inputField: {
    height: 34,
    padding: 0
  },
  inputLabel: {
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    transform: 'translate(14px, 10px) scale(1)',
  },
  fullWidth: {
    marginTop: 6,
    width: '100%',
    flex: 1
  },
  messageContainer: {
    border: `1px solid ${theme.scrollThumbColor}`,
    flex: 1,
    display: "flex",
    justifyContent: "center",
    overflowY: "auto",
    background: theme.chatBGColor,
  },
  disabledInput: {
    cursor: "not-allowed",
    opacity: 0.6,
    color: theme.iconColor,
    pointerEvents: "none",
  },
  loaderContainer: {
    display: "flex",
    alignItems: "center",
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize
  },
  loader: {
    alignSelf: 'center',
    marginRight: 20,
  },
  actionButton: {
    float: "right",
    margin: "10 0 0",
    padding: "5px 16px",
    "&$disabledButton": {
      backgroundColor: theme.customInputBGColor,
      color: theme.TextColor,
      opacity: 0.8
    },
  },
  disabledButton: {},
  terminalContainer: {
    fontSize: theme.headerTextFontSize,
    marginBottom: 14,
  },
  terminalLabel: {
    color: theme.iconColor,
    fontWeight: 400,
    marginRight: 6,
  },
  terminalValue: {
    color: theme.palette.primary.main,
    fontWeight: 500
  }
});

export default styles;
